export default {
  home: {
    lang: 'EN',
    lang_cn: '繁體中文',
    lang_en: '英文',
    form_title: '【亞洲咖啡音樂節 x V27 首展 | 3月6 - 8日】',
    form_title2: '立即登記  搶先預訂V27',
    submit: '提交',
    mandatory: '必須填寫',
    yes: "是",
    no: "否",
    lastName: '姓氏',
    firstName: '名字',
    enterLastName: '請輸入姓氏',
    enterFirstName: '請輸入名字',
    emailAddress: '電郵',
    enterEmail: '請輸入電郵',
    rightEmail: '請輸入正確的郵箱！',
    mobileNumber: '手提電話',
    enterPhone: '請輸入電話號碼',
    rightPhone: '請輸入正確的電話！',
    privacyPolicy: '本人/我們同意錦龍、其聯屬公司、子公司及聯營公司根據收集個人資料聲明 及私隱政策聲明使用本人/我們的個人資料作直接營銷用途。',
    appellation: '稱謂',
    selectAppellation: '請選擇稱謂',
    corporateClient: '企業客戶',
    selectLanguage: '選擇語言',
    pleaseSelectLanguage: '請選擇語言',
    InformationSubmitted: '提交成功，謝謝!',
    success: '提交成功！',
    pleaseWriteName: '公司名稱',
    pleaseWriteName_: '如是，請提供公司名稱',
    agree_: '本人/我們已詳細閱讀並同意',
    statement_: '收集個人資料聲明',
    policy_: '私隱政策聲明',
    and: ' 及 ',
    corporateClient_: '請選擇企業客戶',
    _policy: '請選擇私隱政策',
    remark: '備註',
    fullStop: '。',
    exception: '網絡異常，請稍候再提交！',
    pay: "立即支付 $1,000"
  },
  appellation: {
    Sir: '先生',
    lady: '女士',
    Miss: '小姐',
    PhD: '博士',
    professor: '教授',
  },
  carOption: {
    cartitle: '心儀車型',
    car1: 'V27 (RHD)',
    car2: 'V27 Sport (AWD)',
    carModel_: '請選擇心儀車型',
  },
  successPage: {
    congratulations: '恭喜您！您已成功預訂',
    unfinished: '您未完成支付！',
    rePayment: '重新支付',
    error: '訪問參數錯誤！',
    confirm: '確定',
    cancel: '取消',
    Cancelled: '您已取消！',
    toHome: '您確認關閉，回到首頁？',
    rePay: '您確認重新支付意向金嗎？',
    wait1: '正在確認支付結果',
    wait: '預計 5 秒內完成，請勿關閉頁面',
  }
}

